import React, { memo } from 'react'
import { IoStarSharp } from "react-icons/io5";
const Star = memo(() => {
  return (
    <div style={{color:"gold"}}><IoStarSharp /> <IoStarSharp /> <IoStarSharp /> <IoStarSharp /> <IoStarSharp /></div>
  )
})

export default Star